import React, { FC } from 'react';
import { ListItemProps } from '@components/Inputs/Autocomplete/types';
import { TypographyWithElipsis } from '@components/TypographyElipsis';
import { Checkbox, IconButton, MenuItem } from '@mui/material';
import { TrashIcon } from '@utils/iconsDefs';

const RemovableListItem: FC<
  ListItemProps & {
    onRemove: () => void;
  }
> = ({
  props: { className, ...props },
  option,
  state: { selected },
  multiple,
  onRemove,
}) => {
  return (
    <MenuItem
      component="li"
      sx={{ color: selected ? 'grey.1000' : 'grey.900' }}
      {...props}
    >
      {multiple && <Checkbox checked={selected} />}

      <TypographyWithElipsis
        variant="body1"
        color="inherit"
        sx={{ width: '100%' }}
      >
        {option.label}
      </TypographyWithElipsis>

      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      >
        <TrashIcon width={20} height={20} style={{ minWidth: 20 }} />
      </IconButton>
    </MenuItem>
  );
};

export default RemovableListItem;
